<script lang="ts" setup>
import type { IProps } from './solutions-textWithWhiteBoxes.types'

defineProps<IProps>()
</script>

<template>
  <UiSection>
    <div class="text-with-boxes">
      <div class="text-with-boxes__content">
        <UiHeader
          :header="header"
          position="left"
        />

        <div
          class="text-with-boxes__text text-with-boxes__text--first"
          v-html="text"
        />

        <div
          class="text-with-boxes__text text-with-boxes__text--second"
          v-html="textSecond"
        />

        <UiButton
          v-if="button"
          class="text-with-boxes__button"
          :to="button.to"
        >
          {{ button.text }}
        </UiButton>
      </div>
      
      <div class="text-with-boxes__numbers">
        <UiNumbers
          v-if="numbers.length"
          :numbers="numbers"
          type="box"
          color="purple"
        />

        <p class="text-with-boxes__subtext">
          {{ subtext }}
        </p>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.text-with-boxes {
  max-width: 156rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @include atM {
    display: flex;
    gap: 6.7rem;
  }

  &__content {
    max-width: 94.3rem;
    width: 100%;
  }

  &__text {
    margin-top: 1.6rem;
    font-weight: 500;
  }

  &__text--first {

    font-size: 2rem;
    line-height: 2.8rem;

    @include atM {
      margin-top: 4rem;
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__text--second {
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.4rem;

    @include atM {
      margin-top: 3.2rem;
      font-size: 1.8rem;
      line-height: 2.4rem;
    }
  }

  &__button {
    margin-top: 4rem;
  }

  &__subtext {
    @include body-2-medium;
    margin-top: 3.2rem;
    color: $text-200;
  }
}
</style>
